export interface Article {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  content: string;
  category: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  tags: string[];
  slug: string;
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '2026早春穿搭趋势：法式优雅回归，这5个元素必须拥有',
    excerpt: '法式穿搭以简约、优雅、慵懒著称，2026早春这一风格强势回归。本文为你解析法式穿搭的核心元素，让你轻松穿出巴黎女人的高级感。',
    cover: 'https://readdy.ai/api/search-image?query=French%20style%20fashion%20editorial%20with%20minimalist%20beige%20and%20cream%20outfits%2C%20Parisian%20street%20style%2C%20warm%20natural%20light%2C%20elegant%20and%20timeless%20aesthetic%2C%20clean%20composition&width=1200&height=600&seq=mogu-article-01&orientation=landscape',
    content: `<p>法式穿搭一直是时尚界的常青树，它以简约而不简单、优雅而不刻意的风格深受全球女性的喜爱。2026年早春，法式优雅以更轻盈、更现代的姿态回归大众视野。</p>
    <h2>一、什么是法式穿搭的精髓？</h2>
    <p>法式穿搭的核心在于"effortless chic"——毫不费力的时髦。它强调质感和剪裁，而非繁复的装饰。一件质地优良的白衬衫、一条合身的直筒牛仔裤、一双简约的芭蕾平底鞋，就能打造出最经典的法式造型。</p>
    <p>2026年早春的法式风格在经典基础上融入了一些新的变化：色彩上更加柔和温暖，面料更注重舒适度和垂坠感，单品选择上更加多元化。</p>
    <h2>二、2026早春法式穿搭的5个关键词</h2>
    <h3>1. 亚麻材质</h3>
    <p>亚麻是春夏季最受欢迎的面料之一。2026早春，亚麻西装、亚麻阔腿裤成为法式穿搭的主力单品。选择米色、燕麦色、浅灰色的亚麻单品，搭配简约内搭，慵懒又高级。</p>
    <h3>2. 廓形衬衫</h3>
    <p>告别紧身衬衫，宽松的廓形衬衫成为新宠。不拘泥于传统的白色，柔和的粉色、淡蓝色、奶油色同样值得尝试。将衬衫半塞进裤子里，随性又时髦。</p>
    <h3>3. 微喇叭裤</h3>
    <p>直筒裤依然经典，但微喇叭裤正在悄然回归。裤脚微微散开的设计，视觉上拉长腿部线条，搭配一双小猫跟鞋，法式优雅感满分。</p>
    <h3>4. 针织开衫</h3>
    <p>轻薄的针织开衫是法式穿搭的必备单品。2026早春推荐选择cashmere混纺材质的短款开衫，搭配高腰裤或连衣裙，温柔又有气质。</p>
    <h3>5. 丝巾点缀</h3>
    <p>一条小丝巾是法式穿搭的点睛之笔。可以系在脖子上、手腕上、包带上，甚至是头发上。选择有复古花纹的真丝方巾，瞬间提升整体造型的精致度。</p>
    <h2>三、法式穿搭的配色法则</h2>
    <p>法式穿搭的配色通常以中性色为主，黑白灰、米色、驼色、藏蓝色是最常见的选择。2026早春，我们可以在中性色的基础上，加入一到两件低饱和度的彩色单品，如藕粉色、鼠尾草绿、雾霾蓝，让整体造型更有层次感。</p>
    <p>记住一个简单的原则：全身颜色不超过三种，保持整体的和谐统一。</p>
    <h2>四、法式穿搭的购物清单</h2>
    <p>如果你想打造一个法式衣橱，以下单品可以作为你的入门选择：</p>
    <ul>
    <li>一件质感好的白衬衫</li>
    <li>一条合身的直筒或微喇叭牛仔裤</li>
    <li>一件羊毛混纺的针织开衫</li>
    <li>一件卡其色风衣</li>
    <li>一条真丝小方巾</li>
    <li>一双简约的芭蕾平底鞋或小猫跟鞋</li>
    <li>一个质感好的皮革托特包</li>
    </ul>
    <p>法式穿搭的魅力在于它经得起时间的考验。希望这份2026早春法式穿搭指南能给你带来灵感，让你在这个春天穿出属于自己的法式优雅。</p>`,
    category: '穿搭教程',
    author: '时尚编辑小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20fashion%20editor%20portrait%20with%20elegant%20style%2C%20warm%20lighting%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-article-01&orientation=squarish',
    date: '2026-08-05',
    readTime: '8分钟',
    tags: ['法式穿搭', '早春穿搭', '穿搭趋势', '时尚指南'],
    slug: 'french-style-spring-trend-2026'
  },
  {
    id: 'a2',
    title: '黄黑皮底妆这样画！专业化妆师的选色秘诀大公开',
    excerpt: '黄黑皮选粉底色号总是踩雷？专业化妆师手把手教你如何根据自己的肤色色调选择最合适的底妆产品，从此告别假面感。',
    cover: 'https://readdy.ai/api/search-image?query=Professional%20makeup%20artist%20applying%20foundation%20on%20warm%20skin%20tone%20model%2C%20minimalist%20beauty%20studio%20with%20soft%20lighting%2C%20clean%20professional%20beauty%20photography&width=1200&height=600&seq=mogu-article-02&orientation=landscape',
    content: `<p>对于黄黑皮女生来说，选对粉底色号一直是一道难题。色号选白了像"假面"，选深了又怕暗沉。今天，我们请到了资深专业化妆师，为大家详细讲解黄黑皮底妆的选色秘诀。</p>
    <h2>一、先搞清楚你的肤色色调</h2>
    <p>很多人以为黄黑皮就是"暖色调"，其实这是一个误区。黄黑皮同样可以分为暖调、冷调和中性调。</p>
    <p>简单的判断方法：在自然光下观察手腕内侧的血管颜色。如果血管偏绿色，你是暖调；如果偏蓝色或紫色，你是冷调；如果两者都有，你是中性调。</p>
    <h2>二、不同色调的粉底选择</h2>
    <h3>暖调黄黑皮</h3>
    <p>选择带有黄色或金色底调的粉底液，色号名称中通常包含"warm"、"golden"、"honey"等字眼。避免选择偏粉调的粉底，那会让你的脸看起来发灰。</p>
    <h3>冷调黄黑皮</h3>
    <p>选择带有红色或玫瑰色底调的粉底液。这类肤色比较少见，但选对粉底后妆效会非常自然通透。</p>
    <h3>中性调黄黑皮</h3>
    <p>恭喜你，大多数色号都能驾驭。建议选择中性调的粉底液，妆效最为自然。</p>
    <h2>三、试色的正确方法</h2>
    <p>很多人在手背上试色，但这是不准确的。正确的试色部位是下颌线与脖子的交界处。将粉底液涂抹在这个位置，在自然光下观察颜色是否与脖子和脸部自然融合。</p>
    <p>建议同时试2-3个相近的色号，等待5-10分钟看粉底氧化后的颜色再做决定。</p>
    <h2>四、黄黑皮底妆推荐清单</h2>
    <p>以下是几款黄黑皮友好的粉底液推荐：</p>
    <ul>
    <li>适合干皮：选择水润光泽型粉底液，含有保湿成分更佳</li>
    <li>适合油皮：选择控油哑光型粉底液，持妆力强</li>
    <li>适合混合皮：选择轻薄透气型粉底液，打造自然裸妆感</li>
    </ul>
    <p>记住，底妆的目的不是让你变白，而是让肤色看起来均匀、自然、有光泽。选对适合自己的色号，你的底妆就成功了一大半。</p>`,
    category: '美妆测评',
    author: '美妆编辑CC',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20beauty%20editor%20portrait%20with%20flawless%20makeup%2C%20warm%20lighting%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-article-02&orientation=squarish',
    date: '2026-08-03',
    readTime: '6分钟',
    tags: ['底妆', '黄黑皮', '化妆教程', '粉底液推荐'],
    slug: 'warm-skin-tone-foundation-guide'
  },
  {
    id: 'a3',
    title: '国货彩妆崛起：这10个国产品牌完全不输国际大牌',
    excerpt: '从完美日记到花西子，国货彩妆近年来的表现令人惊艳。我们为你盘点了10个值得关注的优质国产彩妆品牌，品质和颜值双双在线。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20beauty%20brands%20cosmetics%20displayed%20on%20minimalist%20white%20surface%20with%20traditional%20Chinese%20aesthetic%20elements%2C%20warm%20natural%20lighting%2C%20clean%20editorial%20style&width=1200&height=600&seq=mogu-article-03&orientation=landscape',
    content: `<p>近年来，国货彩妆以肉眼可见的速度崛起。从包装设计到产品品质，从成分研发到品牌理念，国货彩妆已经不再是当年"平价替代"的代名词，而是以独立自信的姿态与各大国际品牌并驾齐驱。</p>
    <h2>一、国货彩妆为什么越来越受欢迎？</h2>
    <p>首先是品质的提升。越来越多的国货品牌在研发上投入了大量资源，与全球顶尖的实验室和原料供应商合作，产品品质有了质的飞跃。</p>
    <p>其次是文化的自信。花西子以东方美学为核心设计理念，将中国传统文化元素融入产品设计，不仅在国内收获了忠实粉丝，在国际市场上也备受瞩目。</p>
    <p>最后是性价比的优势。相较于同等品质的国际品牌，国货彩妆的价格更加亲民，让更多消费者能够享受到高品质的彩妆产品。</p>
    <h2>二、10个值得关注的国货彩妆品牌</h2>
    <h3>1. 花西子</h3>
    <p>以东方美学为核心，每一款产品都是一件艺术品。明星产品：空气蜜粉、同心锁口红。</p>
    <h3>2. 完美日记</h3>
    <p>产品线丰富，上新速度快，是国货彩妆的领军品牌。明星产品：小细跟口红、动物眼影盘。</p>
    <h3>3. 彩棠</h3>
    <p>专业彩妆师品牌，产品以高品质和专业性著称。明星产品：三色遮瑕盘、修容盘。</p>
    <h3>4. 花知晓</h3>
    <p>少女心满满的彩妆品牌，包装精致可爱。明星产品：独角兽系列眼影、腮红。</p>
    <h3>5. INTO YOU</h3>
    <p>唇泥品类的开创者，质地独特，显色度高。明星产品：女主角唇泥系列。</p>
    <p>……以及更多优秀品牌等待你去发现。</p>
    <h2>三、如何选择适合自己的国货彩妆？</h2>
    <p>建议从品牌的明星单品入手，这些产品经过市场验证，品质更有保障。同时关注产品的成分表，选择适合自己肤质的产品。</p>
    <p>国货彩妆的春天已经到来，让我们一起支持和见证国货品牌的蓬勃发展。</p>`,
    category: '美妆测评',
    author: '美妆编辑艾米',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20beauty%20editor%20portrait%20with%20fresh%20makeup%2C%20warm%20lighting%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-article-03&orientation=squarish',
    date: '2026-08-01',
    readTime: '10分钟',
    tags: ['国货彩妆', '彩妆推荐', '美妆品牌', '花西子'],
    slug: 'chinese-beauty-brands-top-10'
  },
  {
    id: 'a4',
    title: '小个子女生穿搭终极指南：155cm也能穿出170cm的气场',
    excerpt: '身高不是限制时尚的因素。通过合理运用穿搭技巧，小个子女生同样可以穿出超模般的气场和比例。这篇终极指南将彻底改变你的穿搭方式。',
    cover: 'https://readdy.ai/api/search-image?query=Petite%20woman%20in%20stylish%20outfit%20that%20creates%20elongated%20silhouette%2C%20bright%20minimalist%20studio%2C%20warm%20natural%20lighting%2C%20confident%20fashion%20editorial%20style&width=1200&height=600&seq=mogu-article-04&orientation=landscape',
    content: `<p>很多小个子女生总觉得穿衣受限，但其实只要掌握了正确的穿搭技巧，155cm也可以穿出170cm的视觉效果。今天，我们就来系统性地梳理小个子穿搭的核心法则。</p>
    <h2>一、小个子穿搭的核心原则：优化比例</h2>
    <p>显高的本质不是让身高真的变高，而是通过穿搭来优化身体的视觉比例。核心就是四个字：提高腰线。当腰线位置上移，腿部在视觉上就被拉长了，整个人自然显得更高。</p>
    <h2>二、上衣选择技巧</h2>
    <h3>1. 首选短款上衣</h3>
    <p>短款上衣能够自然地将腰线提高，搭配高腰下装效果最佳。长度在肚脐上方2-3厘米最为理想。</p>
    <h3>2. V领优于圆领</h3>
    <p>V领能够延长颈部线条，让上半身看起来更加修长。避免选择高领和半高领的设计，那会让脖子显得短。</p>
    <h3>3. 塞衣角法则</h3>
    <p>如果穿长款上衣，一定要把衣角塞进裤子里。全塞、半塞、只塞前面都可以，关键是露出腰线。</p>
    <h2>三、下装选择技巧</h2>
    <h3>1. 高腰是标配</h3>
    <p>所有下装优先选择高腰款式，腰线在哪里，腿就从哪里开始。</p>
    <h3>2. 九分裤最友好</h3>
    <p>九分裤露出脚踝，在视觉上有一个"截断"效果，让腿部线条更清晰。搭配浅口鞋效果更佳。</p>
    <h3>3. 避免过于宽大的裤腿</h3>
    <p>过于宽大的阔腿裤会横向拉伸视觉，让整个人显得矮胖。选择适度宽松的直筒裤或微喇叭裤更加合适。</p>
    <h2>四、鞋子的选择</h2>
    <p>尖头鞋延长腿部线条，浅口鞋露出更多脚背，裸色鞋与肤色融为一体——这些都是小个子选鞋的思路。鞋跟高度3-5厘米最为舒适且实用。</p>
    <h2>五、配饰的妙用</h2>
    <p>长项链、竖条纹、同色系搭配……这些都能在视觉上产生纵向延伸的效果。避免使用过宽的腰带和过大的包包，它们会横向切割你的身体比例。</p>
    <p>记住，时尚不分身高，自信才是最好的配饰。希望这份指南能帮助每一位小个子女生找到属于自己的穿搭信心。</p>`,
    category: '穿搭教程',
    author: '时尚编辑小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20petite%20fashion%20editor%20portrait%20with%20confident%20smile%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-article-04&orientation=squarish',
    date: '2026-07-28',
    readTime: '9分钟',
    tags: ['小个子穿搭', '显高穿搭', '穿搭技巧', '身材搭配'],
    slug: 'petite-girl-fashion-guide'
  },
  {
    id: 'a5',
    title: '2026春夏配饰趋势：这些"小东西"让你的穿搭高级10倍',
    excerpt: '配饰虽小，却是穿搭中画龙点睛的关键。2026春夏的配饰趋势有什么新变化？从首饰到包包再到发饰，一次看尽所有流行元素。',
    cover: 'https://readdy.ai/api/search-image?query=Trendy%20accessories%20collection%20including%20jewelry%20scarves%20and%20bags%20styled%20on%20minimalist%20surface%2C%20warm%20golden%20lighting%2C%20elegant%20editorial%20fashion%20photography&width=1200&height=600&seq=mogu-article-05&orientation=landscape',
    content: `<p>穿搭中有一个颠扑不破的真理：配饰决定了造型的上限。同样的基础款穿搭，配上不同的配饰，可以呈现出截然不同的风格。2026春夏，配饰趋势有哪些值得关注的变化？让我们一起来看看。</p>
    <h2>一、首饰：大而简约</h2>
    <p>2026春夏的首饰趋势走向了两个极端：要么大而醒目，要么精致到极致。大尺寸的金属耳环、层叠的项链、宽版的手镯都将是热门单品。材质上，金色和银色平分秋色，珍珠元素依然流行。</p>
    <h2>二、包袋：迷你与超大并存</h2>
    <p>包包的趋势呈现出有趣的"两极分化"：迷你包依然流行，但超大托特包也强势回归。迷你包适合约会和派对，超大托特包则是通勤和旅行的理想选择。</p>
    <h2>三、发饰：回归浪漫</h2>
    <p>发饰在2026春夏迎来了全面复兴。丝绸发圈、珍珠发夹、缎带发箍……各种浪漫元素纷纷登场。特别是大蝴蝶结发饰，无论是在秀场还是在街头，都是高频出现的时尚元素。</p>
    <h2>四、丝巾：不止是丝巾</h2>
    <p>丝巾的用途在2026春夏被发挥到了极致。系脖子、绑头发、装饰包包……一条丝巾可以有十几种不同的玩法。选择一条色彩丰富的小方巾，是提升穿搭精致度最经济的方式。</p>
    <h2>五、腰带：点睛之笔</h2>
    <p>一条精致的腰带可以瞬间提升整体造型的质感。2026春夏推荐选择细腰带，金属扣设计简单大方，搭配连衣裙或西装外套都非常出彩。</p>
    <h2>六、配饰搭配的黄金法则</h2>
    <p>最后分享一个配饰搭配的小技巧：全身上下重点突出1-2处配饰即可，不要"全副武装"。如果戴了大耳环，项链就选择简约款式；如果背了亮眼的包包，首饰就低调一些。让配饰之间相互配合，而不是相互竞争。</p>`,
    category: '潮流单品',
    author: '时尚编辑艾米',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20accessories%20editor%20portrait%20with%20stylish%20jewelry%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-article-05&orientation=squarish',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['配饰趋势', '春夏搭配', '首饰推荐', '时尚搭配'],
    slug: 'spring-summer-accessories-trend-2026'
  },
  {
    id: 'a6',
    title: '护肤成分党必看：烟酰胺、视黄醇、玻尿酸到底怎么选？',
    excerpt: '面对琳琅满目的护肤成分，是不是经常感到无从下手？这篇成分科普文章将为你讲清楚三大热门护肤成分的功效、使用方法和搭配禁忌。',
    cover: 'https://readdy.ai/api/search-image?query=Skincare%20ingredients%20displayed%20with%20scientific%20diagrams%20on%20minimalist%20white%20surface%2C%20botanical%20elements%2C%20soft%20natural%20lighting%2C%20clean%20educational%20beauty%20photography&width=1200&height=600&seq=mogu-article-06&orientation=landscape',
    content: `<p>随着护肤知识的普及，越来越多的消费者开始关注产品的成分表。烟酰胺、视黄醇、玻尿酸……这些听起来很专业的成分名称，到底各自有什么作用？应该怎么选择和搭配？今天就来做一次全面的成分科普。</p>
    <h2>一、烟酰胺：全能型选手</h2>
    <p>烟酰胺，又称维生素B3，是护肤界公认的"万金油"成分。它的主要功效包括：控油、美白、修复皮肤屏障、抗炎、抗衰老。</p>
    <p>适用人群：几乎所有肤质都可以使用，尤其适合油性和混合性肌肤。</p>
    <p>使用建议：新手从低浓度（2%-5%）开始建立耐受，逐步提升到10%。早晚均可使用，但需要注意防晒。</p>
    <h2>二、视黄醇：抗老王牌</h2>
    <p>视黄醇是维生素A的衍生物，是目前公认最有效的抗衰老成分之一。它可以促进胶原蛋白生成，加速细胞更新，改善细纹和皱纹。</p>
    <p>适用人群：有抗老需求的人群，但不建议孕妇使用。</p>
    <p>使用建议：只能晚间使用，从低浓度（0.1%-0.3%）开始，每周2-3次，逐步建立耐受。使用期间必须做好防晒。</p>
    <h2>三、玻尿酸：保湿之王</h2>
    <p>玻尿酸是一种天然存在于人体内的多糖，具有超强的保湿能力。一个玻尿酸分子可以锁住1000倍自身重量的水分。</p>
    <p>适用人群：所有肤质，尤其是干性肌肤。</p>
    <p>使用建议：在皮肤微湿的状态下使用效果最佳，后续需要叠加面霜来锁住水分。</p>
    <h2>四、成分搭配避坑指南</h2>
    <p>烟酰胺+视黄醇：可以搭配使用，但建议早晚分开，烟酰胺白天用，视黄醇晚上用。</p>
    <p>烟酰胺+酸类：不建议同时使用，会产生刺激性。如果都要用，建议早晚分开。</p>
    <p>玻尿酸：几乎可以和所有成分搭配，是成分界的"好人缘"。</p>
    <p>选择护肤品不要盲目追热门，了解自己的肤质和需求，才是科学护肤的第一步。</p>`,
    category: '护肤干货',
    author: '护肤专家诺诺',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20skincare%20expert%20portrait%20with%20glowing%20skin%20and%20professional%20look%2C%20clean%20background&width=80&height=80&seq=mogu-avatar-article-06&orientation=squarish',
    date: '2026-07-20',
    readTime: '8分钟',
    tags: ['护肤成分', '烟酰胺', '视黄醇', '玻尿酸', '科学护肤'],
    slug: 'skincare-ingredients-guide'
  },
];